import { style } from '@xstyled/styled-components';
/** Provides styling to truncate single-line text. */
export const isTruncated = style({
    prop: 'isTruncated',
    cssProperty: function () {
        return {
            overflow: 'hidden',
            'text-overflow': 'ellipsis',
            'white-space': 'nowrap'
        };
    },
    states: {}
});
/** Provides styling to truncate multi-line text. */
export const maxLines = style({
    prop: 'maxLines',
    cssProperty: function (value) {
        return {
            display: '-webkit-box',
            overflow: 'hidden',
            '-webkit-line-clamp': `${value}`,
            '-webkit-box-orient': 'vertical'
        };
    },
    states: {}
});
export const wordBreak = style({
    prop: 'wordBreak'
});
